import type { ICampaignConstructorParams } from "@services/sdk/interfaces";
import Benefit from "@services/sdk/models/benefit";
import type { ID } from "@services/sdk/types";
import { map } from "ramda";

class Campaign {
	public static ConstructList(
		arrParams: Array<ICampaignConstructorParams>,
	): Array<Campaign> {
		return map(Campaign.Construct)(arrParams);
	}

	public static Construct(params: ICampaignConstructorParams): Campaign {
		return new Campaign(params);
	}

	responseData: ICampaignConstructorParams;

	constructor(params: ICampaignConstructorParams) {
		this.responseData = params;
	}

	get id(): ID {
		return this.responseData.campaignId;
	}

	get name(): string {
		return this.responseData.title;
	}

	get description(): string {
		return this.responseData.description;
	}

	get code(): string {
		if (!this.responseData.code) {
			return "";
		}

		return this.responseData.code;
	}

	get amount(): string {
		const benefit = this.benefits.find((b) => b.isValidType);

		if (!benefit) {
			return "";
		}

		return benefit.value;
	}

	get benefits(): Array<Benefit> {
		if (!this.responseData.benefits) {
			return [];
		}

		return Benefit.ConstructList(this.responseData.benefits);
	}
}

export default Campaign;
